import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axiosHttp from "services/axiosHttp";

//CREATE ACTION
export const createExpenseBudget = createAsyncThunk("createExpenseBudget", async (data, { rejectWithValue }) => {
	try {
		const response = await axiosHttp.post(`expense/budget/create`, data);
		return response.data;
	} catch (err) {
		if (!err.response) {
			throw err;
		}
		return rejectWithValue(err.response.data);
	}
});

const ExpenseBudgetCreateSlice = createSlice({
	name: "ExpenseBudgetCreateSlice",
	initialState: {
		isLoading: false,
		isError: false,
		error: null,
		data: null,
	},

	//reset state
	reducers: {
		resetExpenseBudgetCreateState: (state) => {
			state.isLoading = false;
			state.isError = false;
			state.error = null;
			state.data = null;
		},
	},

	extraReducers: (builder) => {
		builder.addCase(createExpenseBudget.pending, (state) => {
			state.isLoading = true;
			state.isError = false;
		});

		builder.addCase(createExpenseBudget.fulfilled, (state, action) => {
			state.isLoading = false;
			state.isError = false;
			state.data = action.payload;
		});

		builder.addCase(createExpenseBudget.rejected, (state, action) => {
			state.isLoading = false;
			state.isError = true;
			state.error = action.payload;
		});
	},
});

export default ExpenseBudgetCreateSlice.reducer;
export const { resetExpenseBudgetCreateState } = ExpenseBudgetCreateSlice.actions;
